import { useState } from 'react'
import { Globe, Coins, Calendar, Clock, Check, ArrowLeft } from 'lucide-react'
import { COUNTRIES, ALL_CURRENCIES, getDefaultCurrency } from '../lib/localization'
import { DATE_FORMATS, TIMEZONES } from '../data/seed'

export default function Preferences({ prefs, onSave, onNavigate }) {
  const [country, setCountry] = useState(prefs?.country || 'Nigeria')
  const [currency, setCurrency] = useState(prefs?.currency || 'NGN')
  const [dateFormat, setDateFormat] = useState(prefs?.dateFormat || 'DD/MM/YYYY')
  const [timezone, setTimezone] = useState(prefs?.timezone || TIMEZONES[0])
  const [saved, setSaved] = useState(false)

  const handleCountryChange = (c) => {
    setCountry(c)
    const def = getDefaultCurrency(c)
    setCurrency(def.code)
  }

  const save = () => {
    onSave?.({ country, currency, dateFormat, timezone })
    setSaved(true)
    setTimeout(() => setSaved(false), 2200)
  }

  return (
    <div className="p-8 lg:p-10 space-y-8 animate-fade-in">
      {/* {onNavigate && (
        <button onClick={() => onNavigate('dashboard')} className="btn-ghost text-xs flex items-center gap-1.5 mb-4">
          <ArrowLeft size={14} /> Back to Dashboard
        </button>
      )} */}
      <div className="flex items-end justify-between">
        <div>
          <h1 className="text-2xl font-bold text-ink">Preferences</h1>
          <p className="text-sm text-muted mt-1">Regional and display preferences for your workspace.</p>
        </div>
        {saved && <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-emerald-700"><Check size={14} /> Preferences saved</span>}
      </div>

      <div className="surface p-7 max-w-2xl space-y-7">
        <div>
          <label className="label-above flex items-center gap-2"><Globe size={13} /> Country</label>
          <select value={country} onChange={(e) => handleCountryChange(e.target.value)} className="input-flat">
            {COUNTRIES.map((c) => (<option key={c}>{c}</option>))}
          </select>
          <p className="text-[11px] text-muted mt-1.5">Determines compliance labels, legal templates, and default currency.</p>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Coins size={13} /> Currency</label>
          <select value={currency} onChange={(e) => setCurrency(e.target.value)} className="input-flat">
            {ALL_CURRENCIES.map((c) => (
              <option key={c.code} value={c.code}>{c.symbol} {c.code}</option>
            ))}
          </select>
          <p className="text-[11px] text-muted mt-1.5">All financial values will display with this currency symbol.</p>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Calendar size={13} /> Date Format</label>
          <div className="flex gap-3">
            {DATE_FORMATS.map((f) => (
              <button
                key={f}
                onClick={() => setDateFormat(f)}
                className={`px-4 py-2 text-xs font-semibold border transition-colors ${
                  dateFormat === f ? 'border-brand bg-brand-soft text-brand' : 'border-neutral-200 text-neutral-500 hover:text-ink'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="label-above flex items-center gap-2"><Clock size={13} /> Timezone</label>
          <select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="input-flat">
            {TIMEZONES.map((tz) => (<option key={tz}>{tz}</option>))}
          </select>
        </div>

        <div className="pt-2">
          <button onClick={save} className="btn-primary">Save Preferences</button>
        </div>
      </div>
    </div>
  )
}
